import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';

var config = process.env;

class ChangePurchaseComponent extends Component {
    
    constructor(){
        super();
        this.state = {
            items: {},
            initialItems: {},
            inFavour: 0
        }
    }
  
    componentWillMount() {
        this.loadProducts();
    }
    
    loadProducts = () => {
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'purchase/'+ this.props.originalPurchase, request)
        .then(results => { return results.json(); })
        .then(data => {
            let inFavour = 0;
            const initialItems = this.convertProductsToDict(data.data.purchase.products, false);
            const itemsWithZeroQuantity = this.convertProductsToDict(data.data.purchase.products, true);
            this.setState({ inFavour: inFavour, initialItems: initialItems, items: itemsWithZeroQuantity });
            this.props.onChangeData(itemsWithZeroQuantity, inFavour);
        });
    }

    convertProductsToDict = (products, initializeToZero) => {
        return products.reduce((dict, product) => {
            dict[product.code] = { 
                ...product, 
                quantity: initializeToZero ? 0 : product.quantity 
            };
            return dict;
        }, {});
    }

    drawTable = () => {
        return (
            <table id="change-purchase-table" style={{width: '100%'}}>
                <thead>
                    <tr role="row">
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '10%'}}>Código</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '30%'}}>Nombre</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '10%'}}>Cantidad</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '15%'}}>Precio</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '15%'}}>Descuento</th>
                        <th className="table-purchase" rowSpan="1" colSpan="1" style={{width: '20%'}}>Precio final</th>
                    </tr>
                </thead>                
                { this.drawTableItems() }
            </table>
        );
    }

    drawTableItems = () => {
        var map = this.state.items;
        var index = 0;
        var items = [];
        for (const [key, value] of Object.entries(map)) {
            items.push(this.drawRow(key, value, index));
            index++;
        }
        if (index === 0) {
            items.push(
                <tr key="no-items"><td colSpan="6" style={{textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)'}}>No tienes elementos</td></tr>
            )
        }
        return (<tbody>{ items }</tbody>)
    }

    upQuantity = (code) => {
        const products = { ...this.state.items };
        let quantity = parseInt(products[code].quantity);
        let inFavour = this.state.inFavour - quantity * products[code].price * (1 - (products[code].discount / 100));
        
        quantity += 1;
        
        if (quantity <= this.state.initialItems[code].quantity) {
            products[code] = { ...products[code], quantity };
            inFavour += quantity * products[code].price * (1 - (products[code].discount / 100));
            this.setState({ inFavour: inFavour, items: products }, () => {
                this.props.onChangeData(this.state.items, inFavour);
            });
        }
    }
    
    downQuantity = (code) => {
        const products = { ...this.state.items };
        let quantity = parseInt(products[code].quantity);
        
        let inFavour = this.state.inFavour - quantity * products[code].price * (1 - (products[code].discount / 100));
        
        quantity -= 1;
        
        if (quantity >= 0) {
            products[code] = { ...products[code], quantity };
            inFavour += quantity * products[code].price * (1 - (products[code].discount / 100));
            this.setState({ inFavour: inFavour, items: products }, () => {
                this.props.onChangeData(this.state.items, inFavour);
            });
        }
    }

    drawRow = (code, item, index) => {
        return(
            <tr role="row" className="odd table-purchase-item" key={ item.code } style={{background: (index % 2 === 0) ? '#ffffff' : '#fcfcfc' }}>
                <td className="table-purchase-item">{item.code}</td>
                <td className="table-purchase-item">{item.name}</td>      
                <td className="table-purchase-item">
                    <div className="row" style={{marginLeft: '0', marginRight: '0'}}>
                        <div className="col" style={{padding: '0', cursor: 'pointer'}} onClick={() => this.downQuantity(item.code)}>
                            <span className="input-group-text" style={{padding: '4px'}}>-</span>
                        </div>
                        <div className="col" style={{marginTop: '2px'}}>
                            {item.quantity}
                        </div>
                        <div className="col" style={{padding: '0', cursor: 'pointer'}} onClick={() => this.upQuantity(item.code)}>
                            <span className="input-group-text" style={{padding: '4px'}}>+</span>
                        </div>
                    </div>
                </td>
                <td className="table-purchase-item">{convertToMoney(item.price)}</td>
                <td className="table-purchase-item">{item.discount}</td>
                <td className="table-purchase-item">{convertToMoney(item.quantity * item.price * (1 - (item.discount / 100)))}</td>
            </tr>
        );
    }

    // Función de debounce
    debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    render() {
        return (
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div style={{fontSize: '24px', textAlign: 'center'}}>
                        <label>Seleccione cuales juegos de la compra se van a devolver</label>
                    </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item p-3">
                            { this.drawTable() }
                        </li>
                        <div style={{fontSize: '24px', textAlign: 'center'}}>
                            <label>Total a favor: </label>
                            <strong style={{marginLeft: '13px', color: "#0a780a"}}>$ <span id="total_price_in_favour">{convertToMoney(this.state.inFavour)}</span></strong>
                        </div>
                    </ul>
                </div>
            </div>
        );
    }
}

export default ChangePurchaseComponent;